import { Dispatch, MiddlewareAPI } from 'redux';
import { getDomainSelector } from 'common/selectors';
import Cookies from 'universal-cookie';
import {
  ReducerAction,
  REDUX_BASKET_ADD,
  REDUX_BASKET_CERTAIN_QUANTITY_ADD,
  REDUX_BASKET_REMOVE,
  REDUX_BASKET_REMOVE_QUANTITY,
  REDUX_BASKET_UPDATED,
  REDUX_SHOPPING_LIST_ADD,
  REDUX_SHOPPING_LIST_REMOVE,
} from './actions';
import { dispatchWishlistEvent } from './utils/shopping-list';
import { SHOPPING_LIST_COOKIE_KEY } from 'common/constants';
import { parseShoppingListCookie } from 'features/products/ducks/utils';

const handleShoppingListChange = (store: MiddlewareAPI) => {
  const cookies = new Cookies();
  const cookieValue = cookies.get(SHOPPING_LIST_COOKIE_KEY);
  const items = parseShoppingListCookie(cookieValue);

  const list = items.map((item) => item.id);
  const domain = getDomainSelector(store.getState());
  dispatchWishlistEvent(domain, list);
};

export const createMiddleware = () => (store: MiddlewareAPI) => {
  if (!__IS_SERVER__) {
    document.body.addEventListener('basket:update', (e) => {
      store.dispatch({
        type: REDUX_BASKET_UPDATED,
        payload: (e as CustomEvent).detail,
      });
    });
  }

  return (next: Dispatch) => (action: ReducerAction) => {
    switch (action.type) {
      case REDUX_BASKET_ADD:
        document.body.dispatchEvent(
          new CustomEvent('basket:add', { detail: { id: action.payload, quantity: 1 } }),
        );
        break;
      case REDUX_BASKET_CERTAIN_QUANTITY_ADD:
        document.body.dispatchEvent(
          new CustomEvent('basket:add', {
            detail: { id: action.payload.code, quantity: action.payload.quantity },
          }),
        );
        break;
      case REDUX_BASKET_REMOVE:
        document.body.dispatchEvent(
          new CustomEvent('basket:delete:element', { detail: { id: action.payload } }),
        );
        break;
      case REDUX_BASKET_REMOVE_QUANTITY:
        document.body.dispatchEvent(
          new CustomEvent('basket:remove', {
            detail: { id: action.payload.code, quantity: action.payload.quantity },
          }),
        );
        break;
      case REDUX_SHOPPING_LIST_ADD:
      case REDUX_SHOPPING_LIST_REMOVE: {
        handleShoppingListChange(store);
        break;
      }
      default:
        return next(action);
    }
  };
};
